var $b4648eea35c475d4$exports = {};
$b4648eea35c475d4$exports = {
    "maximum": `Najvi\u{161}e`,
    "minimum": `Najmanje`
};


export {$b4648eea35c475d4$exports as default};
//# sourceMappingURL=sr-SP.mjs.map
